/*
 * @Author: 陈小英 13880788935@163.com
 * @Date: 2024-04-18 10:47:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-09 11:14:16
 * @FilePath: \operation-center\src\views\websiteAdmin\antireptileSet\components\frequencySet\business\tableLogic.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import api from '@/api/'

export const strategyCommand = {
  edit(data) {
    this.isEdit = true
    this.visible = true
   this.$nextTick(() => {
     const find = this.platformList.find(
       (item) =>
         String(item.project) === String(data.project) &&
         String(item.staff_style) === String(data.staff_style) &&
         String(item.type) === String(data.type)
     )
      this.waitItem = { ...data, line_id: Number(find.id) }
    })
  },
  delete(data) {
    const _this = this
    this.$confirm({
       title: '删除',
      content: '删除后，会删除该条数据，同时已启用状态的相关平台对应页的联系方式将会被清空。确认删除？',
      cancelText: '取消',
      okText: '确认',
      async onOk() {
        const res = await api.contactDelete({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      },
    })
  },
}
export const strategyCommandType = {
  edit(data) {
    this.isEdit = true
    this.visible = true
    this.$nextTick(() => {
      this.waitItem = { ...data }
    })
  }
}
